module.exports = __webpack_public_path__ + "static/media/404.e4301010.gif";